import { render } from "./MailRegistrationComponent.vue?vue&type=template&id=20692583&scoped=true"
import script from "./MailRegistrationComponent.vue?vue&type=script&lang=js"
export * from "./MailRegistrationComponent.vue?vue&type=script&lang=js"

import "./MailRegistrationComponent.vue?vue&type=style&index=0&id=20692583&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20692583"]])

export default __exports__